<template>
    <img ref="qrcode" class="qrcode" />
</template>

<script>
import qrcode from 'qrcode';

export default {
    props: {
        value: { type: String, required: true },
        options: { type: Object, default: () => ({ width: 300 }) }
    },
    mounted() {
        this.$watch('$props', this.generate, { immediate: true, deep: true });
    },
    methods: {
        generate() {
            qrcode.toDataURL(this.value, this.options, (error, url) => {
                /* istanbul ignore if */
                if (error) {
                    throw error;
                }

                this.$refs.qrcode.src = url;
            });
        }
    }
};
</script>
